/* ============================================================
   HYPEST — Sticky add-to-cart (mobiel)  ·  TAAK #5
   ------------------------------------------------------------
   Niet-brekend gedrag:
     - Dupliceert GEEN form-/cart-logica. De sticky-knop is een
       dunne proxy: bij klik triggert hij de ECHTE koopknop
       (`.product-form__submit`) via .click(). Alle Wonder-logica
       (variant-validatie, AJAX-cart, error-states) blijft intact.
     - Verschijnt pas wanneer de echte koopknop UIT beeld scrollt
       (IntersectionObserver). Verdwijnt weer zodra die in beeld is.
     - Spiegelt productnaam, prijs en de disabled/sold-out-staat
       van de echte knop, zodat de balk altijd klopt met de variant.
     - Werkt alleen wanneer er een echte koopknop bestaat; anders
       no-op (faalt stil, breekt niets).

   Markup wordt server-side gerenderd door het `sticky_atc`-blok in
   sections/main-product.liquid. Dit script verbindt die markup met
   de bestaande product-form.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-hypest-sticky-atc]');
    if (!bar) return;

    // De ECHTE koopknop binnen de PDP (Wonder rendert deze in het
    // buy_buttons-blok). Zonder echte knop: niets te proxien.
    var realButton = document.querySelector('.product-form__submit, .js-add-to-cart, button[name="add"]');
    var proxyButton = bar.querySelector('[data-hypest-sticky-atc-button]');
    var priceTarget = bar.querySelector('[data-hypest-sticky-atc-price]');
    if (!realButton || !proxyButton) return;

    // ---- 1. Klik-proxy: stuur door naar de echte knop. ----
    proxyButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (realButton.disabled) return;
      // Echte knop afvuren -> Wonder's product-form handelt alles af.
      realButton.click();
    });

    // ---- 2. Disabled/sold-out spiegelen vanaf de echte knop. ----
    function syncDisabled() {
      var isDisabled = realButton.disabled;
      proxyButton.disabled = isDisabled;
      proxyButton.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      // Label volgt de echte knop (Add to cart / Sold out / ...).
      var realLabel = realButton.querySelector('span');
      var proxyLabel = proxyButton.querySelector('[data-hypest-sticky-atc-label]');
      if (realLabel && proxyLabel) {
        var text = (realLabel.textContent || '').trim();
        if (text) proxyLabel.textContent = text;
      }
    }

    // ---- 3. Prijs spiegelen vanaf het price-blok van de PDP. ----
    // We lezen de live-gerenderde prijs (incl. variant-updates die
    // Wonder doet) uit het bestaande price-blok i.p.v. zelf te rekenen.
    function syncPrice() {
      if (!priceTarget) return;
      // De kortingslink toont zelf beide bedragen en werkt ze bij na een maatwissel.
      if (priceTarget.hasAttribute('data-hypest-discounted')) return;
      var source =
        document.querySelector('[id^="price-"] .price__sale .price-item--sale') ||
        document.querySelector('[id^="price-"] .price-item--regular') ||
        document.querySelector('[id^="price-"] .price-item') ||
        document.querySelector('.wt-product__price .price-item');
      if (source) {
        var text = (source.textContent || '').trim();
        if (text) priceTarget.textContent = text;
      }
    }

    // Observeer wijzigingen aan de echte knop (variant-switch zet
    // disabled aan/uit) en aan het price-blok (variant-prijs update).
    var moButton = new MutationObserver(function () {
      syncDisabled();
    });
    moButton.observe(realButton, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      childList: true,
      subtree: true,
    });

    var priceBlock = document.querySelector('[id^="price-"]') ||
      document.querySelector('.wt-product__price');
    if (priceBlock) {
      var moPrice = new MutationObserver(function () {
        syncPrice();
      });
      moPrice.observe(priceBlock, { childList: true, subtree: true, characterData: true });
    }

    // ---- 4. Zichtbaarheid via IntersectionObserver. ----
    // Toon de balk zodra de echte koopknop NIET meer zichtbaar is
    // (de bezoeker is voorbij de normale ATC gescrold).
    function syncStickyPad() {
      var visible = bar.classList.contains('is-visible');
      var h = visible ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      document.documentElement.classList.toggle('hypest-sticky-atc-pad', visible);
      document.documentElement.style.setProperty('--hypest-sticky-atc-h', (h || 72) + 'px');
    }

    // HYPEST 2026-09-20 Design: sticky must not cover oz chips — incl. first paint.
    // Show only when buy is out AND chips are outside the bottom sticky band.
    // chipsClear defaults false until first IO callback (avoids first-paint flash).
    if ('IntersectionObserver' in window) {
      var buyOut = false;
      var chipsClear = false;
      var buySeen = false;
      var chipsSeen = false;
      var chips =
        document.querySelector('variant-selects') ||
        document.querySelector('.product-form__input') ||
        document.querySelector('.wt-product__option');

      function applyStickyVisibility() {
        // Altijd in beeld op telefoon: foto blijft groot, knop onderaan.
        // Maat-chips blijven tappen via z-index, niet via de balk verbergen.
        bar.classList.add('hypest-sticky-ready');
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        syncStickyPad();
      }

      var ioBuy = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            buySeen = true;
            buyOut = !entry.isIntersecting;
            applyStickyVisibility();
          });
        },
        { root: null, rootMargin: '0px 0px -72px 0px', threshold: 0 }
      );
      ioBuy.observe(realButton);

      if (chips) {
        function bandRootMargin() {
          // Root = bottom sticky band only (~96px). Chips here ⇒ hide sticky.
          var band = 96;
          var topInset = Math.max(0, (window.innerHeight || 800) - band);
          return '-' + topInset + 'px 0px 0px 0px';
        }
        var ioChips = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              chipsSeen = true;
              // Intersecting the bottom band ⇒ chips NOT clear.
              chipsClear = !entry.isIntersecting;
              applyStickyVisibility();
            });
          },
          { root: null, rootMargin: bandRootMargin(), threshold: 0 }
        );
        ioChips.observe(chips);
        window.addEventListener(
          'resize',
          function () {
            ioChips.unobserve(chips);
            ioChips.disconnect();
            ioChips = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  chipsSeen = true;
                  chipsClear = !entry.isIntersecting;
                  applyStickyVisibility();
                });
              },
              { root: null, rootMargin: bandRootMargin(), threshold: 0 }
            );
            ioChips.observe(chips);
          },
          { passive: true }
        );
      } else {
        chipsClear = true;
        chipsSeen = true;
      }

      // Force hidden until first IO ticks.
      bar.classList.remove('is-visible');
      bar.classList.remove('hypest-sticky-ready');
      syncStickyPad();
    }

    // Keep pad in sync if class flips elsewhere.
    var moVis = new MutationObserver(syncStickyPad);
    moVis.observe(bar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', syncStickyPad, { passive: true });

    // hypest-harden-v2: keep sticky in lockstep with size requirement
    document.addEventListener('change', function () {
      syncDisabled();
      syncPrice();
    }, true);
    document.addEventListener('variant:change', function () {
      syncDisabled();
      syncPrice();
    });

    // ---- 5. Chatknop boven de balk (Design-check 2026-09-28). ----
    // CSS zet de chatknop boven de koopbalk zodra html.hypest-chat-lift er is.
    // Die klasse komt er alleen als de maatknoppen en de echte koopknop NIET
    // in de hoek boven de balk liggen, zodat de chatknop nooit een knop afdekt.
    // Zonder IntersectionObserver blijft de chatknop weg (veilige standaard).
    if ('IntersectionObserver' in window) {
      var chatTargets = [realButton];
      document
        .querySelectorAll('fieldset.product-form__input, variant-selects, .wt-product__option')
        .forEach(function (el) {
          chatTargets.push(el);
        });
      var chatBusy = [];
      var chatIo = null;
      function chatSync() {
        var busy = chatBusy.some(function (b) { return b; });
        document.documentElement.classList.toggle('hypest-chat-lift', !busy);
      }
      function chatWatch() {
        if (chatIo) chatIo.disconnect();
        chatBusy = chatTargets.map(function () { return true; });
        // Hoek = balk + ruimte + chatknop (64px) + marge.
        var zone = Math.ceil(bar.getBoundingClientRect().height || 72) + 96;
        var inset = Math.max(0, (window.innerHeight || 800) - zone);
        chatIo = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var i = chatTargets.indexOf(entry.target);
              if (i > -1) chatBusy[i] = entry.isIntersecting;
            });
            chatSync();
          },
          { root: null, rootMargin: '-' + inset + 'px 0px 0px 0px', threshold: 0 }
        );
        chatTargets.forEach(function (el) {
          chatIo.observe(el);
        });
      }
      chatWatch();
      window.addEventListener('resize', chatWatch, { passive: true });
    }

    // Eerste sync.
    syncDisabled();
    syncPrice();
    syncStickyPad();
  }

  function start() {
    // Mobile-only + idle: cheap win for DCL/TBT on Meta in-app.
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    // Sticky visibility is UX-critical on first paint @390 — don't defer 1.2s.
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(function () { init(); });
    } else {
      setTimeout(init, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
